module.exports = __webpack_public_path__ + "img/team_goya.293c80a4.jpg";